export default "__VITE_ASSET__BJagkBhh__"